// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HuPU","toggleWrap":"styles_toggleWrap__zhMDT","content":"styles_content__pANHh","selectAreaCode":"styles_selectAreaCode__3iJZt"};